
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}:host{display:block}ol{display:flex;flex-direction:row;flex-wrap:wrap;font-size:var(--fs-sm);list-style:none;margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;max-width:100%;padding-inline-start:0}li:not(:first-child):before{content:">";padding-left:var(--spacing-2-1);padding-right:var(--spacing-2-1)}li:last-child{color:var(--black-700)}a{color:var(--black-800);text-decoration:none}a:hover{color:var(--medium-blue);text-decoration-line:underline}a:focus{outline-offset:var(--offset-sm)}a:active{color:var(--dark-blue)}.previous-page{font-size:var(--fs-sm)}.previous-page:hover:before{text-decoration-line:none}.previous-page:before{color:var(--medium-blue);content:"<";padding-right:var(--spacing-2)}`;